import { IFee } from '@rbi-ctg/menu';

import { FEES } from './constants';
import { IGetStandardizedName } from './types';

export const getStandardizedName = ({ name }: IGetStandardizedName) => FEES[name] ?? name;

export const getFeesByGroup = (fees: IFee[]) =>
  (fees || []).reduce((acc: { [key: string]: number }, val: IFee) => {
    const lowerCaseName = val.name.toLowerCase();
    if (!acc[lowerCaseName]) {
      acc[lowerCaseName] = 0;
    }

    acc[lowerCaseName] += val.totalCents;

    return acc;
  }, {});
